/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-flex:0;-ms-flex:none;flex:none}.pamoinas-vraperis[_ngcontent-%COMP%], [_nghost-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal}.pamoinas-vraperis[_ngcontent-%COMP%]{max-width:calc((100vh - 125px) * 16 / 9);margin-left:auto;margin-right:auto;-ms-flex-direction:column;flex-direction:column}@media screen and (max-width:992px){.pamoinas-vraperis[_ngcontent-%COMP%]{width:100%}}"];
export { styles as styles };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/games.template.scss.shim.ngstyle.js.pre-build-optimizer.js